/* @flow */
// typecheck: ignore file
import React from 'react';
import cx from 'classnames';
import type { Column, Sort } from 'components/SmartTable.jsx';
import type { SetSortAction } from 'reducers/tables';
import { sortDirection } from 'components/SmartTable.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import SmartTableHeaderSorts from 'components/SmartTableHeaderSorts.jsx';
import HovercardBody from 'components/HovercardBody.jsx';
import Hovercard from 'components/Hovercard.jsx';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import { setSort } from 'reducers/tables';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { findIndex } from 'lodash';
import type { GlyphName } from '@remind/r101-glyphs';

import './styles/SmartTableHeaderColumn.scss';

type Props = {
  column: Column,
  sortKey: string,
  setSort: (namespace: string, sortKey: string) => SetSortAction,
}

class SmartTableHeaderColumn extends React.Component {
  props: Props;

  static contextTypes = {
    namespace: React.PropTypes.string.isRequired,
  };

  constructor(props: Props) {
    super(props);
    this.updateSortKeys(props.column);
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.column !== this.props.column) {
      this.updateSortKeys(nextProps.column);
    }
  }

  columnSortKeys = new Set();

  updateSortKeys(column: Column) {
    if (!column.sorts) {
      this.columnSortKeys = new Set();
    } else {
      const sortKeys = column.sorts.map((sort: Sort) => sort.key);
      this.columnSortKeys = new Set(sortKeys);
    }
  }

  isPrimarySort(): boolean {
    return this.columnSortKeys.has(this.props.sortKey);
  }

  directionIcon(): GlyphName {
    if (!this.isPrimarySort()) {
      return 'chevron-down';
    }
    const direction = sortDirection(this.props.sortKey);
    if (direction === 'asc') {
      return 'chevron-up';
    } else {
      return 'chevron-down';
    }
  }

  toggleSort = () => {
    const { column, sortKey } = this.props;
    const sorts = column.sorts;
    if (!sorts || sorts.length === 0) {
      return;
    }

    if (this.isPrimarySort()) {
      const currentIndex = findIndex(sorts, (sort: Sort) => sort.key === sortKey);
      const nextIndex = (currentIndex + 1) % sorts.length;
      this.props.setSort(this.context.namespace, sorts[nextIndex].key);
    } else {
      this.props.setSort(this.context.namespace, sorts[0].key);
    }
  }

  renderSorts() {
    const sorts = this.props.column.sorts;

    // Show collapsed sort menu when just an asc/desc toggle
    if (sorts && sorts.length === 2) {
      return (
        <Button size="small" level="icon" onClick={this.toggleSort}>
          {this.props.column.name}
          <Glyph name={this.directionIcon()} solo />
        </Button>
      );
    } else {
      const layer = (
        <Hovercard className="TableHeaderColumn-card">
          <HovercardBody>
            <SmartTableHeaderSorts data-test="table-header-sorts" namespace={this.context.namespace} column={this.props.column} />
          </HovercardBody>
        </Hovercard>
      );

      return (
        <LayerTrigger ref="trigger" layer={layer} trigger="click" alignment="left" placement="bottom">
          <Button level="icon" size="small">
            {this.props.column.name}
            <Glyph name={this.directionIcon()} solo />
          </Button>
        </LayerTrigger>
      );
    }
  }

  renderTitle() {
    if (this.props.column.sorts) {
      return this.renderSorts();
    } else {
      return (
        <Button className="SmartTableHeaderColumn-noSort" level="icon" size="small">
          {this.props.column.name}
        </Button>
      );
    }
  }

  render() {
    return (
      <th
        className={cx(
        'SmartTableHeaderColumn',
        { 'SmartTableHeaderColumn-primary': this.isPrimarySort() },
      )}>
        {this.renderTitle()}
      </th>
    );
  }
}


function mapDispatchToProps(dispatch: Function) {
  // $FlowFixMe
  return bindActionCreators({ setSort }, dispatch);
}
export { SmartTableHeaderColumn };
export default connect(null, mapDispatchToProps)(SmartTableHeaderColumn);



// WEBPACK FOOTER //
// ./src/components/SmartTableHeaderColumn.jsx